var silence = (function () {
    try {
        return ['1', 'true'].indexOf(process.env.SILENCE) >= 0;
    }
    catch (error) {
        return false;
    }
})();
/**
 * throw new error
 * or
 * use console.error (in process.env.SILENCE='1' | 'true')
 */
export function errorLog(method, desc, filename) {
    var text = "".concat(method, ": ").concat(desc, ".");
    if (filename) {
        text = "".concat(text, " in this file: ").concat(filename);
    }
    if (silence) {
        console && console.error(text);
    }
    else {
        throw new Error(text);
    }
}
//# sourceMappingURL=error-log.js.map